import { ConverterIF } from '@/components/Input/Converter/ConverterIF'
import '@/util/Extension/StringExtensions'

/**
* 半角英数字、"."、"_"のみを許容するinputクラス
*/
export default class PackageNameConverter implements ConverterIF {
    /**
     * @brief	input要素のvalueの値を変換する
     * @param   [in]    target  対象のDOM情報
     * @return	変換後のvalue
     */
    public convertInputValue(target: HTMLInputElement): string {
        if (undefined == target || null == target) {
            return "";
        }

        if ("" === target.value) {
            return "";
        }

        // 制御コードを除外する
        let strReturn = target.value.removeControlCode();

        // 許容文字以外は除外する
        strReturn = strReturn.removeUnUsePackageNameChar();
        return strReturn;
    }

    /**
     * @brief	TextArea要素のvalueの値を変換する
     * @param   [in]    target  対象のDOM情報
     * @return	変換後のvalue
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public convertTextAreaValue(target: HTMLTextAreaElement): string {
        // TextAreaには非対応のため空文字を返す。
        return "";
    }
}